<template>
    <v-container id="search-page">
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <loading :active.sync="isLoading" :is-full-page="true"></loading>
        <v-row class="my-10">
            <v-col>
                <span class="text-tcdc-green header bold">{{$t('searchPage.search')}}</span>
            </v-col>
        </v-row>
        <v-layout mb-3>
            <v-icon large mr-2 class="borderbot-searchmain">mdi-magnify</v-icon>
            <v-text-field
                    id="search-main"
                    solo
                    flat
                    shaped
                    hide-details
                    color="#34A93E"
                    height="60"
                    class="borderbot-searchmain"
                    background-color="transparent"
                    :placeholder="$t('appbar.search')"
                    v-model="keywordSearch"
                    @keyup.enter="onSearch"
            ></v-text-field>
        </v-layout>
        <v-tabs color="#34A93E" v-model="mode" class="mb-7">
            <v-tab>{{$t('searchPage.programs')}}</v-tab>
            <v-tab>{{$t('searchPage.articles')}}</v-tab>
        </v-tabs>
        <div v-if="mode === 0 && searchProgramResult">
            <v-list v-if="searchProgramResult.data.length > 0">
                <v-list-item v-for="(item, i) in searchProgramResult.data" :key="i" class="mb-3">
                    <v-layout column>
                        <v-layout align-center>
                            <v-flex shrink mr-3 cursor-pointer @click="seeDetail('program', item.product_id)">
                                <v-img
                                        v-if="item.img_cover_mobile || item.img_cover_desktop"
                                        :src="item.img_cover_mobile ? item.img_cover_mobile:item.img_cover_desktop"
                                        width="60px"
                                        height="60px"
                                        style="border-radius: 4px;"
                                />
                                <v-img
                                        v-else
                                        :src="require('../../assets/uploadImage.jpg')"
                                        width="60px"
                                        height="60px"
                                        style="border-radius: 4px;"
                                />
                            </v-flex>
                            <v-flex>
                                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('program', item.product_id)">{{item[`name_${lang}`]}}</div>
                                <div v-if="item.event_type" class="grey--text">Type: {{item.event_type}}</div>
                            </v-flex>
                        </v-layout>
                        <v-divider class="mt-3" />
                    </v-layout>
                </v-list-item>
            </v-list>
            <div v-else class="grey--text text-center">
                {{$t('searchPage.no-record')}}
            </div>
            <v-pagination
                    v-if="searchProgramResult.data.length > 0"
                    v-model="searchProgramResult.current_page"
                    :total-visible="7"
                    :length="searchProgramResult.last_page"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    color="#2e8037"
                    @input="onPageChange"
            ></v-pagination>
        </div>
        <div v-if="mode === 1 && searchArticleResult">
            <v-list v-if="searchArticleResult.data.length > 0">
                <v-list-item v-for="(item, i) in searchArticleResult.data" :key="i" class="mb-3">
                    <v-layout column>
                        <v-layout align-center>
                            <v-flex shrink mr-3 cursor-pointer @click="seeDetail('article', item.article_id)">
                                <v-img
                                        v-if="item.cover_img_path"
                                        :src="item.cover_img_path"
                                        width="60px"
                                        height="60px"
                                        style="border-radius: 4px;"
                                />
                                <v-img
                                        v-else
                                        :src="require('../../assets/uploadImage.jpg')"
                                        width="60px"
                                        height="60px"
                                        style="border-radius: 4px;"
                                />
                            </v-flex>
                            <v-flex>
                                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('article', item.article_id)">{{item[`subject_${lang}`]}}</div>
                            </v-flex>
                        </v-layout>
                        <v-divider class="mt-3" />
                    </v-layout>
                </v-list-item>
            </v-list>
            <div v-else class="grey--text text-center">
                {{$t('searchPage.no-record')}}
            </div>
            <v-pagination
                    v-if="searchArticleResult.data.length > 0"
                    v-model="searchArticleResult.current_page"
                    :total-visible="7"
                    :length="searchArticleResult.last_page"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    color="#2e8037"
                    @input="onPageChange"
            ></v-pagination>
        </div>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import Loading from 'vue-loading-overlay';

    export default {
        components: {
            Loading
        },
        async created() {
            this.items[0].text = this.branchName;
            if (this.keyword) {
                this.isLoading = true;
                this.keywordSearch = this.keyword;
                let program = {
                    keyword: this.keyword,
                    tag: this.tag_name,
                    mode: 0,
                    page: 1
                };
                let article = {
                    keyword: this.keyword,
                    tag: this.tag_name,
                    mode: 1,
                    page: 1
                };
                await this.$store.dispatch('Search/onSearch', program);
                await this.$store.dispatch('Search/onSearch', article);
                this.isLoading = false;
            }
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                tag_name: state => state.Branch.tag_name,
                lang: state => state.Branch.lang,
                keyword: state => state.Search.keyword,
                searchProgramResult: state => {
                    if (state.Search.result.program) {
                        return state.Search.result.program;
                    }
                },
                searchArticleResult: state => {
                    if (state.Search.result.article) {
                        return state.Search.result.article;
                    }
                }
            }),
            branchChanged: function () {
                return this.branchName;
            },
            keywordChanged: function () {
                return this.keywordSearch;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
            },
            keywordChanged: function () {
                this.$store.dispatch('Search/onSetKeyword', this.keywordSearch);
            }
        },
        methods: {
            async onSearch() {
                if (this.keyword) {
                    await this.$store.dispatch('Search/onClearResult');
                    // mode (0 = program, 1 = article)
                    this.isLoading = true;
                    let program = {
                        keyword: this.keyword,
                        tag: this.tag_name,
                        mode: 0,
                        page: 1
                    };
                    let article = {
                        keyword: this.keyword,
                        tag: this.tag_name,
                        mode: 1,
                        page: 1
                    };
                    await this.$store.dispatch('Search/onSearch', program);
                    await this.$store.dispatch('Search/onSearch', article);
                    this.isLoading = false;
                }
            },
            onPageChange(page) {
                let x = {
                    keyword: this.keyword,
                    tag: this.tag_name,
                    mode: this.mode,
                    page: page
                };
                this.$store.dispatch('Search/onSearch', x);
            },
            openLink(url) {
                if (url) {
                    window.open(url);
                }
            },
            seeDetail(mode, id) {
                if (id) {
                    switch (mode) {
                        case 'program':
                            this.$router.push({ name: "EventDetail", params: { id: id } });
                            break;

                        case 'article':
                            this.$router.push({ name: "ArticleDetail", params: { id: id } });
                            break;
                    }
                }
            }
        },
        async beforeDestroy() {
            await this.$store.dispatch('Search/onClearResult');
            await this.$store.dispatch('Search/onResetKeyword');
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    href: "/home"
                },
                {
                    text: "SEARCH",
                }
            ],
            mode: 0,
            isLoading: false,
            keywordSearch: ""
        })
    };
</script>

<style lang="scss">
.borderbot-searchmain {
    border-bottom: solid 2px #34A93E;
}
.theme--light.v-input input#search-main,
input#search-main::placeholder {
    font-size: 1.5rem;
    line-height: 36px;
    font-family: "Poppins", "Kanit", sans-serif;
}
.v-text-field input#search-main,
.v-text-field input#search-box {
    height: 60px !important;
    max-height: unset !important;
    font-family: "Poppins", "Kanit", sans-serif;
}

</style>
